import { render, staticRenderFns } from "./PdfToWord.vue?vue&type=template&id=6220ccb2&scoped=true"
import script from "./PdfToWord.vue?vue&type=script&lang=js"
export * from "./PdfToWord.vue?vue&type=script&lang=js"
import style0 from "./PdfToWord.vue?vue&type=style&index=0&id=6220ccb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220ccb2",
  null
  
)

export default component.exports